<template>
  <div class="alinhadivform">
    <SmartTitle heading="1" weight="medium">Importar</SmartTitle>
    <SmartCard class="card align-center alinhaconteudocard">
      <div class="alinhaconteudoform">
        <SmartTitle class="mt-4 col-4" heading="2" weight="medium"
          >Data de Importação</SmartTitle
        >
        <div class="flex align-center my-2 mt-4">
          <form class="flex justify-start mx-1">
            <VSelect
              placeholder="Selecione"
              :items="type"
              label="Cronograma"
              item-text="cronograma"
              item-value="cronograma"
              v-model="typeSelected"
              name="cronograma"
              clearable
              class="xs:col-6 sm:col-12 md:col-6 lg:col-6 pb-1-2"
              @change="atualizaDate"
            >
            </VSelect>
            <SmartInput
              placeholder="Selecione a data"
              type="date-picker"
              v-model="data_from_create"
              :not-after="data_to_create"
              label="Data de importação"
              class="sm:col-6 lg:col-6"
              :disabled-date="disabledBeforeTodayAndAfterAWeek"
              :editable="false"
              :clearable="false"
            />
          </form>
        </div>
        <div class="flex align-center my-2 mt-4">
          <form class="flex justify-start mx-1">
            <SmartInput
              :mask="'V ##.##'"
              placeholder="Digite a nova versão"
              v-model="newVersion"
              :not-after="newVersion"
              type="text"
              label="Nova Versão"
              class="sm:lg:col-6 lg:col-6"
              name="newVersion"
            />
            <span
              class="sm:lg:col-6 lg:col-6 spantop"
              v-for="item in listedCurrent"
              :key="item.id"
            >
              <SmartTitle
                class="alinhasultimaversiontext"
                heading="2"
                weight="medium"
                >Última versão
                <SmartTitle
                  class="alinhasversiontext"
                  heading="4"
                  weight="medium"
                  >Versão {{ item.version }}
                  <SmartTitle
                    class="alinhasultimaatualtext"
                    heading="4"
                    weight="medium"
                    >Última atualização: {{ item.updatedAt }}
                  </SmartTitle>
                </SmartTitle>
              </SmartTitle>
            </span>
          </form>
        </div>
        <div>
          <form class="relative rounded cursor-pointer">
            <div
              id="drop_zone"
              ondrop="dropHandler(event);"
              ondragover="dragOverHandler(event);"
            >
              <input
                name="file"
                type="file"
                id="real-file"
                class="w-full absolute pl-1-2 pt-1-2 rounded cursor-pointer arquivoadd"
                accept="application/pdf"
                @change="alterValueInput"
                variant="solo-inverted"
              />
              <label
                for="real-file"
                class="input-file flex flex-col align-center justify-center border-default rounded cursor-pointer"
              >
                <SmartIcon
                  :size="2"
                  name="paperclip"
                  class="mr-1-2 mb-2 trava"
                  id="custom-button"
                />
                <smartP
                  class="value-file-input text-black font-medium relative"
                  >{{
                    fileUploaded
                      ? fileUploaded.name
                      : "Arraste um arquivo PDF, ou clique para procurar"
                  }}</smartP
                >
              </label>
            </div>
            <div
              v-if="fileUploaded"
              class="flex justify-start mt-4 rounded cursor-pointer"
            >
              <SmartTitle heading="2" weight="medium" class="trava"
                >Arquivo</SmartTitle
              >
            </div>
            <div
              v-if="fileUploaded"
              class="flex justify-start mt-2 rounded cursor-pointer"
            >
              <smartP class="relative justify-start fontfilenameicon">{{
                fileUploaded ? fileUploaded.name : ""
              }}</smartP>
              <SmartIcon
                :size="2"
                name="trash-import"
                class="mr-1-2 mb-2 mt-1 fontfilenameicon"
                id="custom-button"
                @click="trashImport()"
              />
            </div>
            <div class="flex justify-start mt-4">
              <label
                id="labeltextarea"
                class="flex justify-start rounded cursor-pointer"
                >Descrição da Versão</label
              >
            </div>
            <div class="flex justify-start mt-1">
              <textarea
                class="flex flex-col align-center justify-center border-default rounded cursor-pointer inputtextarea"
                name="descriptionManual"
                v-model="descriptionManual"
                id="textarea"
                :placeholder="'\n' + '     Descreva a versão do manual'"
                @click="selectdescriptiion"
                @change="validateDescription"
              ></textarea>
            </div>
            <div class="flex justify-end mt-4">
              <router-link to>
                <SmartButton
                  @click="verifySendStatus"
                  :disabled="disabledUploadButton"
                  :class="
                    this.disabledUploadButton
                      ? 'mt-3 mb-3 ml-1-2 alinhasmartbutton disabledsmartbutton'
                      : 'mt-3 mb-3 ml-1-2 alinhasmartbutton'
                  "
                  >Importar</SmartButton
                >
              </router-link>
              <SmartModal
                v-if="modal"
                v-bind="modal"
                @close.prevent="modal = null"
                @event.prevent="goToImportStatus"
                >{{ modal.text }}</SmartModal
              >
              <SmartModal
                v-if="infoReloadDataModal"
                v-bind="infoReloadDataModal"
                @close.prevent="infoReloadDataModal = null"
                @event.prevent="continueSend"
                >{{ infoReloadDataModal.text }}</SmartModal
              >
            </div>
          </form>
        </div>
      </div>
    </SmartCard>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { formatBRDateTime } from "utils";
import api from "tim-api";

export default {
  data() {
    return {
      type: ["AGENDADA", "AUTOMÁTICA"],
      typeSelected: "",
      data_from_create: "",
      data_to_create: "",
      fileUploaded: "",
      fileValue: "",
      file: "",
      descriptionManual: "",
      modal: null,
      infoReloadDataModal: null,
      listedCurrent: [],
      registrationLogado: [],
      newVersion: "",
    };
  },
  async mounted() {
    await this.fetchCurrent({});
    this.listedCurrent = [
      {
        id: this.listCurrent.manual.id,
        version: this.listCurrent.manual.version.toFixed(1),
        updatedAt: formatBRDateTime(this.listCurrent.manual.updatedAt).replace(
          ",",
          " - "
        ),
        filepath: this.listCurrent.manual.filepath,
      },
    ];
    this.registrationLogado = this.user.registration;
  },
  watch: {
    typeSelected() {
      this.data_from_create = this.data_from_create ? data_from_create : "";
      this.newVersion = this.newVersion ? this.newVersion : "";      
      this.file = this.file ? this.file : "";
      this.fileValue = this.fileValue ? this.fileValue : "";
      this.fileUploaded = this.fileUploaded ? this.fileUploaded : "";
      this.descriptionManual = this.descriptionManual? this.descriptionManual : " ";
    },
  },
  methods: {
    ...mapActions({
      fetchCurrent: "bpo/fetchCurrent",
      createManualNew: "bpo/createManualNew",
    }),
    alterValueInput(event) {
      this.fileUploaded = event.target.files[0];
      this.fileValue = document.getElementById("real-file").value;
      const extPermitidas = ["pdf"];
      const extArquivo = this.fileValue.split(".").pop();
      if (
        typeof extPermitidas.find(function (ext) {
          return extArquivo === ext;
        }) === "undefined"
      ) {
        this.file = "";
        this.fileValue = "";
        this.fileUploaded = "";
        this.infoReloadDataModal = {
          type: "warning",
          title: "Ops!",
          icon: "alert",
          color: "danger",
          thirdButton: "Continuar",
          text: 'Extensão "' + extArquivo + '" não permitida!',
        };
      }
    },
    verifySendStatus() {
      const importMode = this.type.find(
        (item) => item.type === this.typeSelected
      );
      if (importMode && importMode.status === "OK") {
        this.infoReloadDataModal = {
          type: "warning",
          title: "Ops!",
          icon: "alert",
          thirdButton: "Cancelar",
          fourthButton: "Continuar",
          text: "O envio deste arquivo pode acarretar em sobreposição dos dados",
        };
        return false;
      }
      return this.fileUpload();
    },
    continueSend() {
      this.infoReloadDataModal = null;
      this.fileUpload();
    },
    fileUpload() {
      const years = formatBRDateTime(this.data_from_create).substr(6, 4);
      const month = formatBRDateTime(this.data_from_create).substr(3, 2);
      const day = formatBRDateTime(this.data_from_create).substr(0, 2);
      const userLogado = this.registrationLogado;

      this.file = new FormData();
      this.file.set("manual", this.fileUploaded, this.fileUploaded.name);
      this.file.set("registration", userLogado);
      this.file.set(
        "schedule",
        this.typeSelected === "AUTOMÁTICA" ? "AUTOMATIC" : "SCHEDULED"
      );
      this.file.set("version", parseFloat(this.newVersion.replace("V ", "")));
      this.file.set("description", this.descriptionManual);
      this.file.set("importationDate",this.typeSelected === "AUTOMÁTICA" ? "" : years+'-'+month+'-'+day)
      this.showLoadModal();
      api
        .post("sigtim/manual/upload/", this.file, {
          responseType: "blob/json",
        })
        .then(({ data }) => {
          this.modal = {
            type: "success",
            title: "Manual De DB Enviado",
            icon: "accepted",
            buttonText: "Ok",
            fourthButton: "Acessar Histórico de Importação",
            text: "Pronto! Seu arquivo foi enviado e os dados estão sendo processados.",
          };

          this.typeSelected = "";
          this.data_from_create = "";
          this.data_to_create = "";
          this.newVersion ="";
          this.fileUploaded = "";
          this.fileValue = document.getElementById("real-file").value = "";
          this.file = "";
          this.descriptionManual = "";
        })
        .catch((data) => {
          const dataStatusError = "Erro ao tentar realizar a importação !";
          this.modal = {
            type: dataStatusError ? "warning" : "danger",
            title: "Ops!",
            color: dataStatusError ? "warning" : "danger",
            icon: dataStatusError ? "alert" : "refused",
            thirdButton: "Fechar",
            text: dataStatusError,
          };
        });
    },
    showLoadModal() {
      this.modal = {
        type: "default",
        title: "Carregando Arquivo...",
        icon: "union",
        text: "Estamos subindo o arquivo, aguarde um instante...",
      };
    },
    goToImportStatus() {
      this.$router.push({ name: "HistoryImportDb" });
    },
    trashImport() {
      this.modal = {
        type: "success",
        title: this.fileUploaded.name,
        icon: "accepted",
        buttonText: "Ok",
        text: "Excluido o arquivo de importação",
      };
      this.fileValue = document.getElementById("real-file").value = "";
      this.file = "";
      this.fileUploaded = "";
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      if (this.typeSelected === "AUTOMÁTICA") {
        const today = new Date();
        today.setHours(24, 0, 0, 0);
        return (
          date < today || date > new Date(today.getTime() + 1 * 3600 * 1000)
        );
      }
      if (this.typeSelected === "AGENDADA") {
        const today = new Date();
        today.setHours(24, 0, 0, 0);
        return (
          date < today || date > new Date(today.getTime() * 24 * 3600 * 1000)
        );
      } else {
        return true;
      }
    },
    atualizaDate() {
      const today = new Date();
      today.setHours(24, 0, 0, 0);
      return (this.data_from_create =
        this.typeSelected === "AUTOMÁTICA"
          ? new Date(today.getTime() + 1 * 3600 * 1000)
          : new Date(today.getTime() + 14 * 24 * 3600 * 1000));
    },
    validateDescription() {
      if (this.descriptionManual.length < 11) {
        this.modal = {
          type: "warning",
          title: "Ops",
          icon: "alert",
          thirdButton: "Fechar",
          fourthButton: "",
          text: "Obrigatório ter uma breve descrição sobre o manual !",
        };
      }
    },
    selectdescriptiion() {
      this.descriptionManual = this.descriptionManual? this.descriptionManual : " ";
    },
  },
  computed: {
    ...mapGetters({
      listCurrent: "bpo/listManualCurrent",
      user: "auth/user",
    }),
    disabledUploadButton() {
      if (!this.fileUploaded) {
        return true;
      }

      if (!this.data_from_create) {
        return true;
      }

      if (
        !this.newVersion ||
        this.newVersion.length < 5 ||
        this.newVersion === "V 00.0" ||
        this.newVersion === "V 00.00"
      ) {
        return true;
      }

      if (this.descriptionManual.length < 11) {
        return true;
      }

      return !this.typeSelected;
    },
  },
};
</script>
<style lang="scss">
.alinhasultimaversiontext {
  margin-left: 0px;
  position: flex;
  font-size: 19px;
  margin-bottom: 30px;
  color: #737373;
}
.alinhasversiontext {
  margin-left: 0px;
  position: flex;
  font-size: 14px;
  margin-bottom: 30px;
  color: #000000;
}
.alinhasultimaatualtext {
  margin-left: 0px;
  position: flex;
  font-size: 12px;
  margin-bottom: 30px;
  color: #8d8b8b;
}
.spantop {
  margin-top: -7px;
}
.alinhadivform {
  margin-left: 6%;
}
.alinhaconteudoform {
  padding-top: 1%;
  padding-left: 2%;
}
.alinhaconteudocard {
  margin-left: 1.5%;
}
.value-file-input {
  font-size: $font-size-default;
  opacity: $font-opacity-hg;
}
.input-file {
  border: $border-width-default dashed $color-ui-gradient-gray;
  height: 15rem;
}
.v-input.v-select {
  margin-left: 0;
}
.inputtextarea {
  border: solid gray 1px;
  height: 10rem;
  resize: none;
}
.labeltextarea {
  z-index: 2;
}
#real-file {
  height: 15rem;
  width: 63.5rem;
  font-size: 0;
  border: #82c855 transparent 3px;
  &::before {
    content: "";
    height: 19px;
    width: 19px;
    position: absolute;
    background: #ffffff;
  }
}
.relative {
  padding-left: 1%;
  padding-right: 2%;
}
.alinhasmartbutton {
  margin-left: 10px;
  width: 349px;
  height: 40px;
  top: 4px;
}
.disabledsmartbutton {
  background-color: #585757da;
}
.fontfilenameicon {
  color: #7abd54;
  size: 16px;
  font-weight: 500;
}
.arquivoadd {
  height: 400px;
  width: 600px;
  z-index: 1000;
}
</style>
